import type { WidgetService } from "../types";

// Tenant-customisable booking-field labels. A tenant can rename the guest-facing
// input labels per service (e.g. "Party size" → "Number of guests", "Where" →
// "Seating preference", "When" → "Date") by setting services.config.field_labels
// — a plain { key: string } map surfaced verbatim by get_widget_config. Falls
// back to the built-in label when unset or blank, so services that never set it
// render exactly as before.
export type FieldLabelKey = "party_size" | "seating" | "when" | "duration";

export function fieldLabel(
  service: Pick<WidgetService, "config">,
  key: FieldLabelKey,
  fallback: string,
): string {
  const labels = (
    service.config as { field_labels?: Record<string, unknown> } | null
  )?.field_labels;
  const v = labels?.[key];
  return typeof v === "string" && v.trim() ? v.trim() : fallback;
}

// Per-service field VISIBILITY (services.config.hidden_fields, a string[]).
// First use: tenants who seat by service period ("lunch is lunch") hide the
// Duration picker — the booking then keeps the service-type default length.
export function fieldHidden(
  service: Pick<WidgetService, "config">,
  key: string,
): boolean {
  const hidden = (
    service.config as { hidden_fields?: unknown } | null
  )?.hidden_fields;
  return Array.isArray(hidden) && hidden.includes(key);
}
